import React from 'react'
import {Modal, Typography, IconButton, Box, Grid, Button} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import './PurchaseReservationPopup.scss'
import reserveImage from '../../assets/images/reservation-config-modal.jpeg'
import {emailReservationUpgrade} from '../../state/reservation/email-support/action'
import useEmailReservationUpgradeReducer from '../../state/reservation/email-support/reducer'

const PurchaseReservationPopup = props => {
  const {show = false} = props
  const [salesTalk, setSalesTalk] = React.useState(false)
  const [sendEmailData, sendEmailDispatch] = useEmailReservationUpgradeReducer()

  const emailSupportClick = e => {
    emailReservationUpgrade(sendEmailDispatch)
    setSalesTalk(true)
  }

  return (
    <Modal
      style={{position: 'absolute'}}
      open={show}
      onClose={props.onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div className="ap-reservation-modal">
        <IconButton
          size="small"
          className="ap-reservation-modal__btn-close"
          onClick={props.onClose}
        >
          <CloseIcon />
        </IconButton>
        <Grid container item xs={12} style={{width: '800px', height: '450px'}}>
          <Grid item xs={6} className="ap-reservation-modal__grid-design-1">
            <Typography className="ap-reservation-modal__title">Reservations</Typography>
            <Typography className="ap-reservation-modal__sub-title">
              Book assets ahead of time with this premium feature. Learn more.
            </Typography>
            <div className="ap-reservation-modal__button-title">
              <Button
                hidden={salesTalk}
                variant="contained"
                size="large"
                onClick={emailSupportClick}
                style={{color: 'white', backgroundColor: '#eb6e34', textTransform: 'none'}}
              >
                Talk to Customer Success
              </Button>
              <Typography className="ap-reservation-modal__sub-title" hidden={!salesTalk}>
                Thank you for the interest, a Sales representative will talk to you soon via email.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={6}>
            <Typography className="ap-reservation-modal__modal-content-title" />
            <div className="ap-reservation-modal__image-design">
              <img src={reserveImage} alt="Reservation Modal" style={{width: '300px'}} />
            </div>
            <Typography className="ap-reservation-modal__modal-content-sub-title" />
          </Grid>
        </Grid>
      </div>
    </Modal>
  )
}

export default PurchaseReservationPopup
